import RestClient from './RestClient';
import { Sector } from '../../models';

class Sectors extends RestClient {
    constructor() {
        super({
            "model": Sector,
            "entryPoint": "sector",
            "resource": "sector",
            "resources": "sectors",
            "id": "id"
        });
    }

    importFromEdition(sourceEdition) {
        return this.POST(`/${this.entryPoint}/import_from_edition`, {
            source_edition: sourceEdition
        }).then(response => response.json());
    }
}

const SectorsApi = new Sectors();

export default SectorsApi;
